import React, { FC, useCallback, useState } from 'react';
import {
  CandidateLayout,
  DEFAULT_OG_IMAGES,
  SEO_COMMON,
} from '../../layout/candidate/CandidateLayout';
import { Panel } from 'rc-collapse';
import { MinusOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Collapse } from 'antd';
import { TextBlock, TextHeading } from '../../uicomp/atmos/content-block/ContentBlock';
import Form, { FormSchema } from '../../components/form/Form';
import styles from './comon.module.less';
import { useConnection, useUserInfo } from '../../connection/Application';
import { HtmlView } from '../../components/HtmlTemplate/HtmlView';
import { NextSeo } from 'next-seo';
import Utils from '../../utils/Utils';

export type FaqData = {
  faqId?: string;
  question: string;
  answer: string;
  time?: number;
};

const schema: FormSchema = [
  {
    id: 'search',
    type: 'string',
    props: { placeholder: 'Search FAQ here' },
  },
];

export const FAQ: FC<{ data: FaqData[] }> = (props) => {
  const [faqData, setFaqData] = useState<FaqData[]>(props.data);
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const connection = useConnection();
  const user = useUserInfo();
  const handleSearch = useCallback(
    (data) => {
      setLoading(true);
      connection
        .get('faq', { ...data })
        .then((value) => setFaqData(value))
        .catch(() => console.log('Error getting FAQ data'))
        .finally(() => setLoading(false));
    },
    [connection],
  );
  return (
    <CandidateLayout
      title={
        <NextSeo
          canonical="https://www.careers360.lk/faq"
          title="Frequently asked questions relating to job vacancies and recruitment  in Sri Lanka  | Careers360"
          description="Get in touch with our FAQ section if you have any doubts to clarify; most of the concerns of the recruiters and candidates is covered in Careers360 FAQ section"
          openGraph={{
            title: `Frequently asked questions relating to job vacancies and recruitment  in Sri Lanka  | Careers360`,
            description:
              'Get in touch with our FAQ section if you have any doubts to clarify; most of the concerns of the recruiters and candidates is covered in Careers360 FAQ section',
            images: DEFAULT_OG_IMAGES,
          }}
          {...SEO_COMMON}
        />
      }>
      <div className={Utils.mergeClasses({ [styles.spaceWidth]: true, [styles.user]: !!user })}>
        <div className={styles.search}>
          <Form.Form form={form} layout={'inline'} onFinish={handleSearch}>
            <Form.Items schema={schema} />
            <Button type={'primary'} onClick={form.submit} loading={loading}>
              <SearchOutlined />
            </Button>
          </Form.Form>
        </div>
        <TextBlock heading level={1} align={'center'}>
          <TextHeading heading level={1}>
            FAQ
          </TextHeading>
        </TextBlock>
        <Collapse
          bordered={false}
          expandIconPosition={'right'}
          expandIcon={({ isActive }) => (isActive ? <MinusOutlined /> : <PlusOutlined />)}>
          {faqData.map((item) => {
            return (
              <Panel
                className={'fullwidth'}
                header={<HtmlView value={item.question} />}
                key={item.faqId}>
                <HtmlView value={item.answer} />
              </Panel>
            );
          })}
        </Collapse>
      </div>
    </CandidateLayout>
  );
};
